import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import styles from "./IndividualLicenceInformation.module.scss";
import {Button, ErrorMsg, Warning} from "@onegovbugs/onegov-react-components";
import {useSelector, useDispatch} from 'react-redux';
import {getLicenceDetails, process2FA, process2FA2, createApplication, processVerifyIndividual2FA, saveImportExportApplication} from "../../../redux/actions";
import { Import_Export_Licence_Type} from '../../../constants';
import { isCompleted, validate, scrollToError } from "../../../utils/Validation";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";  

const IndividualLicenceInformation = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch();
  const licenceDetails = useSelector(state => state.licenceDetails);
  const application = useSelector(state => state.application);
  const oidc = useSelector(state => state.oidc);

  const [currentLicenceNo, setCurrentLicenceNo] = 
    useState(licenceDetails && licenceDetails.currentLicenceNumber ? licenceDetails.currentLicenceNumber : '');
  const [currentLicenceeGivenName, setCurrentLicenceeGivenName] = 
    useState(licenceDetails && licenceDetails.licenseeGivenName ? licenceDetails.licenseeGivenName : '');
  const [currentLicenceeSurname, setCurrentLicenceeSurname] = 
    useState(licenceDetails && licenceDetails.licenseeSurname ? licenceDetails.licenseeSurname : '');
  const [showErrors, setShowErrors] = useState(false);
  const [licenceInfo, setLicenceInfo] = 
    useState(licenceDetails && licenceDetails.licenceInfo ? licenceDetails.licenceInfo : { isValid: false, errorMessage: '', licenceRowId: ''});
  
  const twoFA = useSelector((state) => state.twoFA);
  const twoFAVerified = twoFA && twoFA.data && twoFA.data.firstName && twoFA.data.firstName!="" ? true : false;


  const [errors, setErrors] = useState({
    currentLicenceNo: false,
    currentLicenceeGivenName: false,
    currentLicenceeSurname: false,
  });

  const validators = [
    {
      fieldName: 'currentLicenceNo',
      fieldValue: currentLicenceNo,
      isValid: isCompleted
    },
    {
      fieldName: 'currentLicenceeGivenName',
      fieldValue: currentLicenceeGivenName,
      isValid: isCompleted
    },
    {
      fieldName: 'currentLicenceeSurname',
      fieldValue: currentLicenceeSurname,
      isValid: isCompleted
    },
  ];

  const isLicenceDetailsChanged = () =>
  {
    return !(currentLicenceNo === licenceDetails.currentLicenceNumber 
      && licenceDetails.licenseeGivenName === currentLicenceeGivenName
      && licenceDetails.licenseeSurname === currentLicenceeSurname)

  }

  useEffect(() => {
    validate(validators, setErrors);
  }, [currentLicenceNo,currentLicenceeGivenName,currentLicenceeSurname]);

  return <div className={styles.mainCont}>

    <div className={'row'}>
      <div className={`col-12`}>
      <h1>Apply for Import / Export Licence</h1>
            <hr/>
            <h2>Licensee Information</h2>
      </div>
    </div> 

    {
      (!licenceInfo.isValid && licenceInfo.errorMessage !== '') && 
      <div className={"row"}>
        <div className={"col-12"}>  
            <Warning type={"error"}>
                <p>{licenceInfo.errorMessage}</p>
            </Warning>
        </div>
      </div>  
    }

    <div className={'row'}>

      <div className={`col-12 col-sm-6`}>
            <label htmlFor={"currentLicenceNo"}>
              Licence No
            </label>
            <input
              className={`${styles.inputBox}`}
              placeholder={'Licence No'}
              value={currentLicenceNo}
              onChange={(event) => {
                setCurrentLicenceNo(event.target.value)
              }}
            />
            {errors.currentLicenceNo && showErrors ? (
              <ErrorMsg 
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Licence No is required."}
              />
            ) : null}
      </div>

    </div>


    <div className={'row'}>

      <div className={`col-12 col-sm-6`}>
        <label htmlFor={"currentLicenceeGivenName"}>
            First Name
          </label>
          <input
            className={`${styles.inputBox}`}
            placeholder={'First Name'}
            value={currentLicenceeGivenName}
            onChange={(event) => {
              setCurrentLicenceeGivenName(event.target.value)
            }}
          />  
            {errors.currentLicenceeGivenName && showErrors ? (
              <ErrorMsg 
                className={"ErrorMsg_error"}
                type={"error"}
                description={"First Name is required."}
              />
            ) : null}            
      </div>


      <div className={`col-12 col-sm-6`}>
          <label htmlFor={"currentLicenceeSurname"}>
              Last Name
            </label>
            <input
              className={`${styles.inputBox}`}
              placeholder={'Last Name'}
              value={currentLicenceeSurname}
              onChange={(event) => {
                setCurrentLicenceeSurname(event.target.value)
              }}         
            />
            {errors.currentLicenceeSurname && showErrors ? (
              <ErrorMsg 
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Last Name is required."}
              />
            ) : null}
        </div>

    </div>

    <div className={`row ${styles.buttonCont}`}>
      <div className={`col-12`}>
        <Button
          disabled={licenceDetails.loading}
          onClick=
          { 
            () => 
            {
              if (validate(validators, setErrors)) {
                setShowErrors(false);
                if (!application.applicationNo)
                {
                  dispatch(
                    getLicenceDetails(
                      currentLicenceNo, 
                      currentLicenceeGivenName, 
                      currentLicenceeSurname, 
                      oidc, (licenceInfo) => {

                        setLicenceInfo(licenceInfo);

                        if(licenceInfo.isValid)
                        {
                          dispatch(
                            createApplication(
                              (res) => {

                                if(res)
                                {
                                    const newApplicationData = {
                                        creatingApplication:false,
                                        createdApplication:true,
                                        applicationID:res.data.applicationId,
                                        licenceType:null,
                                        applicationNo:res.data.applicationNo,
                                        applicationFulfilled:false,
                                        storingAppPayment:false,
                                        applicationFinished:false,
                                        applicationId:res.data.applicationId,
                                    }
                
                                    dispatch(saveImportExportApplication("", () => {

                                      if(twoFAVerified){
                                        window.location = './dashboard';
                                      }
                                      else{
                                        dispatch(processVerifyIndividual2FA((TwoFaUrl)=>{
                                        // dispatch(process2FA2((TwoFaUrl)=>{
                                          sessionStorage["nativespeciesTwoFASource"]="licenceInformation";
                                          window.location = TwoFaUrl;
                                        }))
                                      }  

                                    }, newApplicationData))
                                }                    
                              },
                              Import_Export_Licence_Type
                            )
                          );  
                        }
                    })
                  );
                } else {

                  if (twoFAVerified && !isLicenceDetailsChanged()) {
                    window.location = './dashboard';
                  }

                  // if (twoFAVerified && isLicenceDetailsChanged()) {
                  //   dispatch(
                  //     getLicenceDetails(
                  //       currentLicenceNo, 
                  //       currentLicenceeGivenName, 
                  //       currentLicenceeSurname, 
                  //       oidc, (licenceInfo) => {
                  //         if(licenceInfo.isValid)
                  //         {
                  //           window.location = './dashboard';
                  //         }
                  //         setLicenceInfo(licenceInfo);
                  //     })
                  //   ); 
                  // }                  

                  if (!twoFAVerified || twoFAVerified && isLicenceDetailsChanged()) {
                    dispatch(
                      getLicenceDetails(
                        currentLicenceNo, 
                        currentLicenceeGivenName, 
                        currentLicenceeSurname, 
                        oidc, (licenceInfo) => {

                          if(licenceInfo.isValid)
                          {
                            dispatch(processVerifyIndividual2FA((TwoFaUrl)=>{
                            // dispatch(process2FA2((TwoFaUrl)=>{
                              sessionStorage["nativespeciesTwoFASource"]="licenceInformation";
                              window.location = TwoFaUrl;
                            }))   
                          }
                          setLicenceInfo(licenceInfo);
                      })
                    ); 
                  }
                }                                  
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }
          }
        >Continue</Button>
      </div>
    </div>

  </div>
  
};

export default withRouter(props => <IndividualLicenceInformation {...props}/>);
